
import { Status } from './status';

export class Role {
  id: number = 0;
  name: string = '';
  status: Status = new Status();
  createdAt: Date = new Date();
  updatedAt: Date;
}
